/**
 * @module cercaliagl/view/VWeatherInformation
 */

import $ from 'jquery';
import BaseView from './BaseView';

/**
 * @classdesc
 */
class VWeatherInformation extends BaseView {
  /**
   * @constructor
   */
  constructor() {
    const jqElement = $('<div class="v-weatherinformation mdc-elevation--z4"></div>');

    super(jqElement);

    /**
     * @private
     * @type {import("../LonLat.js").default|undefined}
     */
    this.position_ = undefined;

    /**
     * @private
     * @type {Date}
     */
    this.currentDate = undefined;
  }

  /**
   * @private
   */
  render_() {
    const html = `<span class=date-info>${this.currentDate.toLocaleString()}</span>`;

    this.jqElement_
      .empty()
      .append(html);

    this.show();
  }

  /**
   * @param {number} timestamp Timestamp.
   * @api
   */
  updateData(timestamp) {
    this.currentDate = new Date(timestamp * 1000);
    this.render_();
  }
}

export default VWeatherInformation;
